import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import promiseMiddleware from "redux-promise-middleware";

import thunk from "redux-thunk";

import rootReducer from "./rootReducer";

export default function(initialState, { req, res } = {}) {
  if (!initialState && req) initialState = {};

  return createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(thunk, promiseMiddleware()))
  );
}



// WEBPACK FOOTER //
// ./src/store.js